import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import Container from "@material-ui/core/Container";
import Typography from "../components/Typography";
import { NavLink } from "react-router-dom";
import { AppLinkHrefs } from "../../navigation/navigationHelpers";

function Copyright() {
  return (
    <React.Fragment>
      {"© "}
      <Link component={NavLink} color="inherit" to={AppLinkHrefs.Home}>
        Zero One One
      </Link>{" "}
      {new Date().getFullYear()}
    </React.Fragment>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.secondary.light,
  },
  container: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    display: "flex",
    // https://material-ui.com/components/grid/#negative-margin
    overflowX: "hidden",
  },
  list: {
    listStyle: "none",
    margin: 0,
    padding: 0,
  },
  listItem: {
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
  },
  copyright: {
    paddingTop: 50,
  },
}));

export default function SiteFooter() {
  const classes = useStyles();

  return (
    <Typography component="footer" className={classes.root}>
      <Container className={classes.container}>
        <Grid container direction="column">
          <Grid container spacing={8}>
            <Grid item xs={12} sm={6} md={3} lg={3}>
              <Typography variant="h6" marked="left" gutterBottom>
                Company
              </Typography>
              <ul className={classes.list}>
                <li className={classes.listItem}>
                  <Typography variant="body1" color="inherit">
                    Zero One One, Inc.
                  </Typography>
                  <Typography variant="body1" color="inherit">
                    2093 Philadelphia Pike #3011
                  </Typography>
                  <Typography variant="body1" color="inherit">
                    Claymont, DE 19703
                  </Typography>
                  <Typography variant="body1" color="inherit">
                    United States of America
                  </Typography>
                  <Typography variant="body1" color="inherit">
                    +1 (929) 334 3336
                  </Typography>
                </li>
              </ul>
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3}>
              <Typography variant="h6" marked="left" gutterBottom>
                Contact
              </Typography>
              <ul className={classes.list}>
                <li className={classes.listItem}>
                  <a href="mailto:hello@wheelhorse.io">hello@wheelhorse.io</a>
                </li>
              </ul>
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3}>
              <Typography variant="h6" marked="left" gutterBottom>
                Stay in touch
              </Typography>
              <Link
                component={NavLink}
                to={AppLinkHrefs.Subscribe}
                key="subscribe"
              >
                Subscribe
              </Link>
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3}>
              <Typography variant="h6" marked="left" gutterBottom>
                Legal
              </Typography>
              <ul className={classes.list}>
                <li className={classes.listItem}>
                  <Link component={NavLink} to={AppLinkHrefs.Terms} key="terms">
                    Terms
                  </Link>
                </li>
              </ul>
            </Grid>
          </Grid>
          <Grid container direction="column" className={classes.copyright}>
            <Grid item>
              <Copyright />
            </Grid>
            <Grid item>
              <Typography variant="caption">
                {"Icons made by "}
                <Link
                  href="https://www.icons8.com"
                  rel="sponsored"
                  title="Icons8"
                >
                  Icons8
                </Link>
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Typography>
  );
}
